import { useAuthV2, type PersonaState } from "@/lib/authv2/store";
import { activePersona, isSecondaryActive } from "@/lib/authv2/persona";
import { PersonaIcon } from "./PersonaIcon";
import { usePersonaSwitch } from "./usePersonaSwitch";

/**
 * Dải màu ở đầu mọi màn khi đang dùng danh phận PHỤ (QĐ 0255, CEO chốt 4a):
 * nhìn là biết mình đang đứng ở vai nào, bấm một nút là về danh phận chính.
 * Danh phận chính thì không vẽ gì — và không đụng tới react-query.
 */
export function PersonaBand() {
  const state = useAuthV2((s) => s.persona);
  if (!state || !isSecondaryActive(state)) return null;
  return <PersonaBandInner state={state} />;
}

function PersonaBandInner({ state }: { state: PersonaState }) {
  const sw = usePersonaSwitch();
  const current = activePersona(state);
  // Lời báo lỗi nằm ở cấp hook (usePersonaSwitch) — gắn thêm ở đây là báo hai lần.
  const back = () => sw.mutate(state.primary);
  const shortBack = state.primary.role.toLowerCase() === "qc" ? `Về ${state.primary.label}` : "Về danh phận chính";

  return (
    <div
      role="status"
      data-testid="persona-band"
      className="flex shrink-0 items-center gap-2 px-4 py-1.5 text-sm text-white"
      style={{ background: "var(--color-info-text)" }}
    >
      <PersonaIcon
        role={current.role}
        department={current.department}
        className="h-4 w-4 shrink-0"
      />
      <span className="min-w-0 flex-1 truncate">
        <span className="hidden sm:inline">Đang dùng với tư cách </span>
        <b>{current.label}</b>
      </span>
      <button
        type="button"
        onClick={back}
        disabled={sw.isPending}
        className="shrink-0 rounded-md border border-white/60 px-3 py-1 text-xs font-semibold hover:bg-white/10 disabled:opacity-60"
      >
        <span className="hidden sm:inline">Về {state.primary.label}</span>
        <span className="sm:hidden">{shortBack}</span>
      </button>
    </div>
  );
}
